module.exports = __webpack_public_path__ + "static/media/logo-serializer.fa36ee80.svg";